module.exports = __webpack_public_path__ + "img/_ms_.5e6e3cb4.svg";